// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
    display: flex;
}
.container {
    width: 100%;
    height: 100%;
}
.flexColumn {
    display: flex;
    flex-direction: column;
}
.flexCenterChildren {
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Components/css/Display.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".flex {\n    display: flex;\n}\n.container {\n    width: 100%;\n    height: 100%;\n}\n.flexColumn {\n    display: flex;\n    flex-direction: column;\n}\n.flexCenterChildren {\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
